<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'DeploymentsSection',
  mounted() {
    this.SET_SECTION('Deployments');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
  },
};
</script>
